import {
  APP_GET_APP_RESOLUTIONS,
  APP_GET_AUDIOLANGS,
  APP_GET_CONFIG,
  APP_GET_SUBLANGS,
  APP_SET_NAVIGATE_MODE,
  APP_SET_PAGE_OPTIONS,
  APP_SET_VIRTUAL_DEBUGGER_STATE
} from 'common/constants/action-types';

export type NavigateMode = 'DIRECTIONAL' | 'POINTER';

export interface PageOptions {
  unmountPage?: boolean;
  pageWrapperActive?: boolean;
}

export interface AppConfigState {
  navigateMode: NavigateMode;
  pageOptions: PageOptions;
  virtualDebuggerEnabled?: boolean;
  subtitles: unknown[];
  audio: unknown[];
  resolutions: unknown[];
}

const INITIAL_STATE: AppConfigState = {
  navigateMode: 'DIRECTIONAL',
  pageOptions: {
    unmountPage: false,
    pageWrapperActive: false
  },
  virtualDebuggerEnabled: false,
  subtitles: [],
  audio: [],
  resolutions: []
};

export default function (state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case APP_GET_CONFIG:
      return {
        ...state,
        ...action.payload
      };
    case APP_GET_SUBLANGS:
      return {
        ...state,
        subtitles: [...action.payload]
      };
    case APP_GET_AUDIOLANGS:
      return {
        ...state,
        audio: [...action.payload]
      };
    case APP_GET_APP_RESOLUTIONS:
      return {
        ...state,
        resolutions: [...action.payload]
      };
    case APP_SET_NAVIGATE_MODE:
      return {
        ...state,
        navigateMode: action.payload
      };
    case APP_SET_PAGE_OPTIONS:
      return {
        ...state,
        ...action.payload,
        pageOptions: {
          ...state.pageOptions,
          ...action.payload
        }
      };
    case APP_SET_VIRTUAL_DEBUGGER_STATE:
      return {
        ...state,
        virtualDebuggerEnabled: action.payload
      };
    default:
      return state;
  }
}
